import { defineComponent as _defineComponent } from 'vue'
import BaseQuestionMarkTooltip from "@/components-UI/BaseQuestionMarkTooltip.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Editor from '@crm-ui/ckeditor';
import { onMounted, ref, watch, computed } from "vue";
import { OfferSingle } from "@/services/offers/OfferSingle";
import { useOfferDetailStore } from "@/store_v3/offerCard";
import { canEditOffers } from "@/utils/checkRole";


interface Props {
    data: object;
    offer: OfferSingle;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferCardDescription',
  props: {
    data: null,
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    data: object;
    offer: OfferSingle;
}



const editor = Editor;
const ckeditor = CKEditor.component;

const textValue = ref('');
const textBox = ref('');
const textBoxHeight = ref(0);
const isDisableEdit = ref(false);
const editableCardBox = ref<HTMLElement | null>(null);
const store = useOfferDetailStore();

const isEdit = computed(() => store.activeEditId === props.data.name);
const canEditOffer = computed(() => canEditOffers());

const config = {
    language: 'ru',
    toolbar: {
        items: [
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'fontColor',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'link',
            'horizontalLine',
        ],
    },
    fontColor: {
        colorPicker: {
            // Use 'hex' format for output instead of 'hsl'.
            format: 'hex',
        },
        colors: [
            {
                color: '#0DA800',
                label: 'Green',
            },
            {
                color: '#F51E44',
                label: 'Red',
            },
        ],
        documentColors: 0,
    },
    forcePasteAsPlainText: false,
    extraAllowedContent: '*(*);*{*}',
    clipboard: {
        retainOnlyPasteData: false,
    },
    pasteFromWordRemoveFontStyles: false,
    pasteFromWordRemoveStyles: false,
};

const onEditorReady = (editor: any): void => {
    editor.editing.view.document.on('clipboardInput', (evt, data) => {
        const pastedData = data.dataTransfer.getData('text/html');

        if (pastedData) {
            data.content = removeColors(editor, pastedData);
        }
    }, { priority: 'high' });

    const toolbarWrapper = editor.ui.view.toolbar.element.closest(".ck-body-wrapper");
    const targetContainer = editableCardBox.value?.$el.querySelector(".editable-card__card");

    if (toolbarWrapper && targetContainer) {
        targetContainer.prepend(toolbarWrapper);
    }
};

const removeColors = (editor: any, data: any) => {
    const allowedColors = ['#0DA800', '#F51E44', 'rgb(13, 168, 0)', 'rgb(245, 30, 68)'];

    const doc = editor.data.htmlProcessor.toView(data);
    const clearStyles = (element) => {
        if (element._styles && element._styles._styles) {
            if (!allowedColors.includes(element._styles._styles.color)) {
                delete element._styles._styles.color;
            }
        }
        if (element._children) {
            element._children.forEach(clearStyles);
        }
    };
    clearStyles(doc);
    return doc;
};

const resetDescription = () => {
    store.resetActiveEdit();
    textValue.value = props.data.value;
    isDisableEdit.value = false;
};

const toggleEdit = (value: boolean) => {
    if (value) {
        store.setActiveEdit(props.data.name);
        textValue.value = props.data.value;
    } else {
        store.resetActiveEdit();
        updateOffer();
    }
};

const updateOffer = async () => {
    const data = {};
    data[props.data.key] = textValue.value;
    const isUpdate = await props.offer.editOffer(data);
    if (isUpdate) store.setIsUpdateOffer(true);
    changeTextboxHeight();
};

const changeTextboxHeight = () => {
    if (props.data.isCollapse) {
        setTimeout(() => {
            textBoxHeight.value = textBox.value.offsetHeight;
        }, 0);
    }
};

onMounted(() => {
    textValue.value = props.data.value;
    changeTextboxHeight();
});

watch(() => textValue.value, () => {
    if (props.data.isShort) {
        const text = textValue.value.replace(/(<([^>]+)>)/ig, '').replaceAll('&nbsp;', '');
        isDisableEdit.value = text.length > 1000;
    }
});

watch(
    () => store.activeEditId,
    (newId) => {
        if (newId !== props.data.name) {
            isDisableEdit.value = false;
        }
    },
);


return { __sfc: true,props, editor, ckeditor, textValue, textBox, textBoxHeight, isDisableEdit, editableCardBox, store, isEdit, canEditOffer, config, onEditorReady, removeColors, resetDescription, toggleEdit, updateOffer, changeTextboxHeight, BaseQuestionMarkTooltip, BaseEditableCard }
}

})